import { styled } from '@/stitches.config';

import { Box, FormField } from '@base-app';

export const FormFieldStyled = styled(FormField, {
  display: 'flex',
  flexDirection: 'column',
  marginRight: '$4',
});

export const StyledLabel = styled(Box, {
  color: '$charcoal300',
  fontWeight: '$medium',
  lineHeight: '$5',
  marginBottom: '$4',
});

export const StyledTarget = styled(Box, {
  color: '$charcoal300',
  fontWeight: '$normal',
  lineHeight: '$5',
});
